<div class="card mt-3">
  <div class="card-body">
    <h3 class="mb-4">{{ 'MENU.DASHBOARD.Edit_Contract' | translate }}</h3>

<form (ngSubmit)="updateProduct()" enctype="multipart/form-data">
  <div class="row">
    <!-- 🧑 User -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">{{ 'MENU.DASHBOARD.user_name' | translate }}</label>
        <select
          class="form-control"
          [(ngModel)]="product.user_id"
          name="user_id"
          required
        >
          <option value="" disabled selected>
            {{ 'MENU.DASHBOARD.select_user' | translate }}
          </option>
          <option *ngFor="let item of InvestorsId" [value]="item.id">
            {{ _translateService.currentLang === 'ar' ? item.name : item.name }}
          </option>
        </select>
        <div *ngIf="!product.user_id" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.select_user_required' | translate }}
        </div>
      </div>
    </div>

    <!-- 📄 Contract Type -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">{{ 'MENU.DASHBOARD.contract_type' | translate }}</label>
        <select
          class="form-control"
          [(ngModel)]="product.contract_type_id"
          name="contract_type_id"
          required
        >
          <option value="" disabled selected>
            {{ 'MENU.DASHBOARD.select_contract_type' | translate }}
          </option>
          <option *ngFor="let item of pages" [value]="item.id">
            {{ _translateService.currentLang === 'ar' ? item.name_ar : item.name_en }}
          </option>
        </select>
        <div *ngIf="!product.contract_type_id" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.select_contract_type_required' | translate }}
        </div>
      </div>
    </div>

    <!-- ⏱ Duration (Months) -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">{{ 'MENU.DASHBOARD.duration_months' | translate }}</label>
        <select
          class="form-select form-control"
          [(ngModel)]="product.duration_months"
          name="duration_months"
          required
        >
          <option value="" disabled selected>
            {{ 'MENU.DASHBOARD.enter_duration' | translate }}
          </option>
          <option value="monthly">{{ 'MENU.DASHBOARD.monthly' | translate }}</option>
           <option value="tow-months">{{ 'MENU.DASHBOARD.two_months' | translate }}</option>
<option value="four-months">{{ 'MENU.DASHBOARD.four_months' | translate }}</option>
          <option value="quarterly">{{ 'MENU.DASHBOARD.quarterly' | translate }}</option>
          <option value="semi_annually">{{ 'MENU.DASHBOARD.semi_annually' | translate }}</option>
          <option value="annually">{{ 'MENU.DASHBOARD.annually' | translate }}</option>
        </select>
        <div *ngIf="!product.duration_months" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.select_duration_required' | translate }}
        </div>
      </div>
    </div>

    <!-- 💰 Investment Amount -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">{{ 'MENU.DASHBOARD.investment_amount' | translate }}</label>
        <input
          type="number"
          class="form-control"
          placeholder="{{ 'MENU.DASHBOARD.enter_investment_amount' | translate }}"
          [(ngModel)]="product.investment_amount"
          name="investment_amount"
          required
        />
        <div *ngIf="!product.investment_amount" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.enter_investment_amount_required' | translate }}
        </div>
      </div>
    </div>

    <!-- 📈 Investment Rate -->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">{{ 'MENU.DASHBOARD.investment_rate' | translate }}</label>
        <input
          type="number"
          class="form-control text-center"
          placeholder="{{ 'MENU.DASHBOARD.enter_investment_rate' | translate }}"
          [(ngModel)]="product.investment_rate"
          name="investment_rate"
          min="0"
          max="100"
          step="0.1"
          required
        />
        <div *ngIf="!product.investment_rate" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.enter_investment_rate_required' | translate }}
        </div>
      </div>
    </div>
     <!-- 📈 Investment Rate max-->
    <div class="col-sm-4">
      <div class="mb-3">
        <label class="form-label">{{ 'MENU.DASHBOARD.investment_rate_max' | translate }}</label>
        <input
          type="number"
          class="form-control text-center"
          placeholder="{{ 'MENU.DASHBOARD.enter_investment_rate' | translate }}"
          [(ngModel)]="product.investment_rate_max"
          name="investment_rate_max"
          min="0"
          max="100"
          step="0.1"
          required
        />
        <div *ngIf="!product.investment_rate_max" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.enter_investment_rate_required' | translate }}
        </div>
      </div>
    </div>

    <!-- 📄 PDF Upload -->
<div class="col-sm-4">
  <div class="mb-3">

    <label class="form-label">
      {{ 'MENU.DASHBOARD.upload_pdf' | translate }}
    </label>

    <!-- Current PDF -->
    <div *ngIf="product.existing_pdf" class="mb-2">
      <a
        [href]="product.existing_pdf"
        target="_blank"
        class="text-primary text-decoration-underline"
      >
        <i class="fas fa-file-pdf text-danger mr-1"></i>
        {{ 'MENU.DASHBOARD.view_current_pdf' | translate }}
      </a>
    </div>

    <!-- Upload new PDF -->
    <input
      type="file"
      class="form-control"
      accept=".pdf"
      (change)="onPdfSelected($event)"
    />

    <small class="text-muted">
      {{ 'MENU.DASHBOARD.leave_empty_keep_pdf' | translate }}
    </small>

  </div>
</div>

  </div>

  <!-- 💾 Submit -->
  <div class="text-start mt-3">
    <button type="submit" class="btn px-4" style="background-color: #cca44c !important; color: #fff;">
      {{ 'MENU.DASHBOARD.save_changes' | translate }}
    </button>
  </div>
</form>

  </div>
</div>
